import { render, staticRenderFns } from "./CssGrid.vue?vue&type=template&id=2567dd13&"
import script from "./CssGrid.vue?vue&type=script&lang=js&"
export * from "./CssGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports